import { inject, Injectable } from "@angular/core"
import { User } from "@angular/fire/auth"
import { Analytics, logEvent, setUserId, setUserProperties } from "@angular/fire/analytics"

@Injectable({
  providedIn: "root",
})
export class AnalyticsService {
  private analytics = inject(Analytics)

  unsetAnalyticsUserProperties() {
    setUserId(this.analytics, null)
  }

  setAnalyticsUserProperties(user: User) {
    if (user) {
      // 1. Set global cross-subdomain User ID (Stitches journeys together)
      setUserId(this.analytics, user.uid)

      // 2. Set sticky User Property for the active domain context
      setUserProperties(this.analytics, {
        tenant_subdomain: this.getSubdomain(),
      })

      // 3. Log explicit event tracking successful cross-subdomain login
      logEvent(this.analytics, "subdomain_login_success", {
        uid: user.uid,
        subdomain: this.getSubdomain(),
      })
    }

  }

  private getSubdomain(): string {
    const parts = window.location.hostname.split(".")
    return parts.length > 2 ? parts[0] : "root_or_local"
  }

}
